<template>
    <div class="bg-base-200 min-h-screen">
        <NuxtLayout :name="$route.fullPath?.includes('admin') ? 'admin' : 'default'">
            <div class="flex grow flex-col items-center justify-center gap-8">
                <h1 class="text-base-content/60 text-center text-4xl font-semibold select-none">
                    {{ errorMessage }}
                </h1>
                <button class="btn btn-primary" @click="handleError">
                    Go back
                </button>
            </div>
        </NuxtLayout>
    </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue';
import type { NuxtError } from '#app';

defineOptions({
    name: 'Error'
});

// todo - remove layout (because what if the error comes from a layout?)

const props = defineProps({
    error: {
        type: Object as PropType<NuxtError>,
        required: true
    }
});

const errorMessage = computed(() => {
    if (props.error.statusCode === 404 && !props.error?.statusMessage) {
        return 'Page not found';
    }

    return props.error.statusMessage?.length ? props.error.statusMessage : 'Something has gone wrong';
});

const route = useRoute();

if (import.meta.dev || import.meta.server || Boolean(route.query.debug)) {
    // if we're in development or on the server side.
    onMounted(() => {
        // eslint-disable-next-line no-console
        console.error(props?.error);
    });
}
useSeoMeta({
    title: `${props.error.statusCode === 404 ? '404 - Page not found' : 'Error'} | Cina's Delicious Cakes`,
    description: 'Cina\'s Delicious Cakes is a home-based cake business in Norwich, offering handcrafted cakes for all occasions.',
    robots: { index: false, follow: true }
});

const handleError = async () => clearError({ redirect: '/' });
</script>
